import axios from 'axios';
import ENDPOINTS from '@utils/apiEndpoints';
import { axiosInstance } from '@utils/axiosInstance';
import { setItem } from '@utils/localStorage';
import { onApiError, onApiSuccess } from '@utils/utilities';

const onSuccess = (response) => {
  const { jwtSignInInfo } = response.data.result;

  if (jwtSignInInfo?.accessToken && jwtSignInInfo.accessToken.length > 0) {
    setItem(
      'accessTokenExpirationTime',
      new Date().getTime() + jwtSignInInfo.accessTokenExpirationTime,
    );
    setItem(
      'refreshTokenExpirationTime',
      jwtSignInInfo.refreshTokenExpirationTime,
    );
    setItem('api_access_token', jwtSignInInfo.accessToken);
    setItem('api_refresh_token', jwtSignInInfo.refreshToken);
    axios.defaults.headers.common['Authorization'] =
      `${jwtSignInInfo.grantType} ${jwtSignInInfo.accessToken}`;
  } else {
    delete axios.defaults.headers.common['Authorization'];
  }
};

export const adminJwtIssueService = (data: {
  admId: string;
  admPwd: string;
}) => {
  return axiosInstance
    .post(ENDPOINTS.ADMIN.AUTH.JWT_ISSUE, data)
    .then((response) => {
      return onApiSuccess(response, () => onSuccess(response));
    })
    .catch((error) => {
      return onApiError(error);
    });
};
